import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'audamatic-ui';
import Text from '@text';

const KeepMePosted = (props) => {
  const { product, store } = props;

  // Import the form component on click, so it's not inlcuded in the initial bundle
  const triggerModal = () => {
    import('./_form/component')
      .then((component) => {
        const KeepMePostedForm = component.default;
        store.modal.openModal('popup', '', {
          title: <Text>keepMePosted.title</Text>,
          component: <KeepMePostedForm sku={product.sku} store={store}/>,
          classNames: 'keep-me-posted',
        });
      });
  };

  return (
    <Button
      onClick={triggerModal}
      variant="tertiary"
      size="large"
      iconLeft={<Icon name="SendMail" />}
      fullWidth={true}
      data-test-id="buttonKeepMePosted"
    >
      <Text>keepMePosted.button.label</Text>
    </Button>
  );
};

KeepMePosted.propTypes = {
  store: PropTypes.object,
  product: PropTypes.object,
};

export default KeepMePosted;
